<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>供应系统</el-breadcrumb-item>
        <el-breadcrumb-item>商品管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'dishesManagement' }">菜品管理</el-breadcrumb-item>
        <el-breadcrumb-item>新增菜品</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="hx-form-container box-shadow">
      <el-form v-loading="formLoading" ref="commodityForm" :model="listParams" :rules="checkListParams" label-width="150px">
        <el-row type="flex">
          <el-col :span="10">
            <el-form-item label="商品分类：" prop="plaGoodCategoryId">
              <el-select clearable style="width: 300px" size="small" v-model="listParams.plaGoodCategoryId" placeholder="请选择商品分类">
                <el-option v-for="item in categoryNameList" :label="item.title" :value="item.id" :key="item.id"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="商品名称：" prop="title">
              <el-input style="width: 300px" size="small" v-model="listParams.title" placeholder="请输入商品别名"></el-input>
            </el-form-item>

            <el-form-item label="商品别名：" prop="alias">
              <el-input style="width: 300px" size="small" v-model="listParams.alias" placeholder="请输入商品别名"></el-input>
            </el-form-item>

            <el-form-item label="商品规格：" prop="plaGoodSpecId">
              <el-select clearable style="width: 300px" size="small" v-model="listParams.plaGoodSpecId" placeholder="请选择商品规格">
                <el-option v-for="item in commoditySpecList" :label="item.title" :value="item.id" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="最小重量：" prop="minWeight">
              <el-input style="width: 300px" size="small" v-model="listParams.minWeight" placeholder="请输入商品最小重量"></el-input>
            </el-form-item>

            <el-form-item label="最大重量：" prop="maxWeight">
              <el-input style="width: 300px" size="small" v-model="listParams.maxWeight" placeholder="请输入商品最大重量"></el-input>
            </el-form-item>
            <el-form-item label="商品图片：" prop="picture">
              <div class="upload-thumbnail-img" :loading="uploading">
                <i class="el-icon-circle-plus-outline upload-icon"></i>
                <input type="file" class="hidden-upload" @change="doUpload" id="uploadDom" />
              </div>
              <div class="wrap-thumbnail-img" v-if="listParams.picture.length > 0">
                <div class="thumbnail-img" v-for="(item, index) in listParams.picture" :key="index">
                  <div class="combined-img">
                    <img :src="item" alt class="thumbnail-img-wrapped" :key="index" />
                    <div class="hover-img">
                      <i class="el-icon-delete el-icon-circle-close-outline close-btn" @click="deleteImg(index)"></i>
                    </div>
                  </div>
                </div>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="!this.$route.query.id">
            <el-form-item label="商品价格：" label-width="350px" prop="price">
              <el-input style="width: 300px" size="small" @change="resetPrice" v-model="listParams.price" placeholder="请输入商品价格">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
            <el-form-item
              v-for="(item, index) in listParams.goodLevelPrices"
              :prop="`goodLevelPrices[${index}].levelPrice`"
              :key="item.id"
              :label="`${item.levelName}-商品价格：`"
              label-width="350px"
              :rules="[
                {
                  required: true,
                  message: '请填写该商品价格',
                  trigger: `blur`,
                },
              ]"
            >
              <el-input style="width: 300px" size="small" :disabled="!listParams.price" v-model="item.levelPrice" :placeholder="`请输入${item.levelName}的商品价格`">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="京东参考价" prop="referencePrice" v-if="listParams.supplyId === '3'">
          <el-input style="width: 300px" size="small" v-model="listParams.referencePrice" placeholder="请输入参考价格">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>

        <!--<el-form-item label="是否参与限购：" prop="isRestriction">-->
        <!--<el-radio v-model="listParams.isRestriction" :label="true">是</el-radio>-->
        <!--<el-radio v-model="listParams.isRestriction" :label="false">否</el-radio>-->
        <!--</el-form-item>-->

        <el-form-item label="限购规则：" prop="supplyRuleIds">
          <el-checkbox-group v-model="listParams.supplyRuleIds" @change="changeSupplyRuleIds">
            <el-checkbox v-for="item in restrictionRuleList" :label="item.id" :key="item.id">{{ item.title }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-collapse accordion v-model="activeName">
          <el-collapse-item v-for="(item, index) in listParams.goodFarmSites" :key="item.value" :name="index">
            {{ item.id }}
            <template slot="title">
              <el-form-item
                :label="`基地${index + 1}：`"
                label-width="100px"
                :prop="`goodFarmSites[${index}].farmId`"
                :rules="{
                  required: true,
                  message: '请选择基地',
                  trigger: `blur`,
                }"
              >
                <el-select size="small" clearable v-model="item.farmId" :disabled="Boolean(listParams.goodFarmSites[index].farmId)" placeholder="请选择基地">
                  <el-option v-for="item in allbase" :key="item.id" :label="item.lable" :value="item.value"> </el-option>
                </el-select>
                <i @click.stop="add(1)" class="el-icon-circle-plus add"></i>
                <i v-if="listParams.goodFarmSites.length > 1" @click.stop="reduce(1, index)" class="el-icon-remove reduce"></i>
              </el-form-item>
            </template>
            <div class="border">
              <div class="flex" v-for="(item, indexs) in listParams.goodFarmSites[index].siteStockProportion" :key="item.value">
                <el-form-item
                  label-width="30px"
                  :prop="`goodFarmSites[${index}].siteStockProportion[${indexs}].siteId`"
                  :rules="[
                    {
                      required: true,
                      message: '请选择供应点',
                      trigger: `blur`,
                    },
                  ]"
                >
                  <el-select size="small" clearable v-model="item.siteId" placeholder="请选择供应点" :disabled="Boolean(listParams.goodFarmSites[index].siteStockProportion[indexs].siteId)">
                    <el-option v-for="item in allSupplyLsit" :key="item.value" :label="item.lable" :value="item.value"> </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  label-width="30px"
                  :prop="`goodFarmSites[${index}].siteStockProportion[${indexs}].stockProportion`"
                  :rules="[
                    {
                      required: true,
                      message: '请输入比例',
                      trigger: `blur`,
                    },
                  ]"
                >
                  <el-input-number size="mini" v-model="item.stockProportion" />%
                  <i @click.stop="add(2, index)" class="el-icon-circle-plus add"></i>
                  <i v-if="listParams.goodFarmSites[index].siteStockProportion.length > 1" @click.stop="reduce(2, index, indexs)" class="el-icon-remove reduce"></i>
                </el-form-item>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>

        <el-form-item label="商品详情：" prop="description" label-width="150px">
          <RichTextarea class="wang-editor-style" v-model="listParams.description" height="450px" />
        </el-form-item>
        <el-form-item class="align-center" style="margin-top: 100px">
          <el-button :disabled="isDisabled" size="small" type="primary" @click="saveAdd('commodityForm')">保存</el-button>
          <el-button size="small" class="mgl20" @click="backToList">返回</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  data() {
    return {
      formLoading: false,
      listParams: {
        supplyId: "",
        plaGoodCategoryId: "",
        title: "",
        alias: "",
        price: "",
        referencePrice: "",
        plaGoodSpecId: "",
        minWeight: "",
        maxWeight: "",
        picture: [],
        supplyRuleIds: [],
        description: "",
        goodLevelPrices: [
          { levelPrice: 0, levelId: "", levelName: "" },
          { levelPrice: 0, levelId: "", levelName: "" },
          { levelPrice: 0, levelId: "", levelName: "" },
          { levelPrice: 0, levelId: "", levelName: "" },
        ],
        goodFarmSites: [
          {
            farmId: "",
            siteStockProportion: [{ siteId: "", stockProportion: 12 }],
          },
        ],
      },
      isDisabled: false,
      commoditySpecList: [],
      restrictionRuleList: [],
      uploading: false,
      method: "",
      checkListParams: {
        plaGoodCategoryId: [
          {
            required: true,
            message: "请选择商品分类",
            trigger: "change",
          },
        ],
        title: [
          {
            required: true,
            message: "请输入商品名称",
            trigger: "blur",
          },
        ],
        alias: [
          {
            required: true,
            message: "请输入商品别名",
            trigger: "blur",
          },
        ],
        price: [
          {
            required: true,
            message: "请输入商品价格",
            trigger: "blur",
          },
        ],
        referencePrice: [
          {
            required: true,
            message: "请输入参考价格",
            trigger: "blur",
          },
        ],
        plaGoodSpecId: [
          {
            required: true,
            message: "请选择商品规格",
            trigger: "change",
          },
        ],
        picture: [
          {
            required: true,
            message: "请选择商品图片",
            trigger: "change",
          },
        ],
        description: [
          {
            required: true,
            message: "请输入商品详情",
            trigger: "blur",
          },
        ],
      },
      categoryNameList: [],
      allSupplyLsit: [],
      allbase: [],
      activeName: [],
      edit: false,
    };
  },
  mounted() {
    if (this.$route.params.supplyId) {
      this.listParams.supplyId = this.$route.params.supplyId;
      this.edit = true;
    }
    if (this.listParams.supplyId === "3") {
      this.checkListParams.referencePrice[0].required = true;
    } else {
      this.checkListParams.referencePrice[0].required = false;
    }
    this.loadCategoryList();
    this.loadGoodSpecList();
    this.loadRestrictionRuleList();
    this.loadAllSupplyLsit();
    this.loadAllbase();
    if (this.$route.query.id) {
      this.loadDetailPage(this.$route.query.id);
    } else {
      this.loadSupplyLsit();
    }
  },
  methods: {
    /**
     * 加载所有供应点
     */
    loadAllSupplyLsit() {
      this.$http({
        url: global.apiUrl + "/logistics/index",
        method: "GET",
        params: {
          supplyId: this.listParams.supplyId,
          pageIndex: 1,
          pageSize: 1000,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            if (res.body.data) {
              const data = res.body.data.dataList || [];
              this.allSupplyLsit = data.map(item => {
                return {
                  value: item.id.toString(),
                  lable: item.title,
                };
              });
            } else {
              this.allSupplyLsit = [];
            }
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 加载所有基地
     */
    loadAllbase() {
      this.$http({
        url: global.apiUrl + "/farm/farm-index",
        method: "GET",
        params: {
          supplyId: this.listParams.supplyId,
          pageIndex: 1,
          pageSize: 1000,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            if (res.body.data) {
              const data = res.body.data.dataList || [];
              this.allbase = data.map(item => {
                return {
                  value: item.farmId.toString(),
                  lable: item.title,
                };
              });
            } else {
              this.allbase = [];
            }
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     *新增
     */
    add(type, index) {
      if (type == 1) {
        this.listParams.goodFarmSites.push({
          farmId: "",
          siteStockProportion: [{ siteId: "", stockProportion: 0 }],
        });
      } else {
        this.listParams.goodFarmSites[index].siteStockProportion.push({
          siteId: "",
          stockProportion: 0,
        });
      }
    },
    /**
     *减少
     */
    reduce(type, index, indexs) {
      if (type == 1) {
        this.listParams.goodFarmSites.splice(index, 1);
        console.log(this.listParams.goodFarmSites);
      } else {
        this.listParams.goodFarmSites[index].siteStockProportion.splice(indexs, 1);
        console.log(this.listParams.goodFarmSites[index].siteStockProportion);
      }
    },
    /**
     * 设置商品价格
     */
    resetPrice() {
      this.listParams.goodLevelPrices.forEach(item => {
        item.levelPrice = this.listParams.price;
      });
    },
    /**
     * 加载供应点
     */
    loadSupplyLsit() {
      this.$http({
        url: global.apiUrl + "/supply/level",
        method: "GET",
        params: {
          supplyId: this.supplyId,
          pageIndex: 1,
          pageSize: 100,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            if (res.body.data) {
              const data = res.body.data.data || [];
              const arry = data.map(item => {
                return {
                  levelPrice: 0,
                  levelId: item.id,
                  levelName: item.levelName,
                };
              });
              this.listParams.goodLevelPrices = arry;
            } else {
              this.listParams.goodLevelPrices = [];
            }
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 初始化商品分类列表数据
     */
    loadCategoryList() {
      this.$http({
        url: global.apiUrl + "/good/goodcategory/findAll",
        method: "GET",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.categoryNameList = res.body.data;
          } else {
            this.categoryNameList = [];
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 初始化商品规格列表数据
     */
    loadGoodSpecList() {
      this.$http({
        url: global.apiUrl + "/good/goodspec/findAll",
        method: "GET",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.commoditySpecList = res.body.data;
          } else {
            this.commoditySpecList = [];
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 初始化限购规则
     */
    loadRestrictionRuleList() {
      this.$http({
        url: global.apiUrl + "/good/supplyrule/findAll",
        method: "GET",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            if (res.body.data) {
              this.restrictionRuleList = res.body.data;
            } else {
              this.restrictionRuleList = [];
            }
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 初始化菜品详情
     * @param id
     */
    loadDetailPage(id) {
      this.formLoading = true;
      this.$http({
        url: global.apiUrl + "/good/gooddetail?id=" + id,
        method: "GET",
      })
        .then(res => {
          this.formLoading = false;
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            if (res.body.data) {
              const arr = [
                {
                  farmId: "",
                  siteStockProportion: [{ siteId: "", stockProportion: 12 }],
                },
              ];
              const data = res.body.data;
              this.listParams.plaGoodCategoryId = data.plaGoodCategoryId;
              this.listParams.title = data.title;
              this.listParams.alias = data.alias;
              this.listParams.price = data.price;
              this.listParams.referencePrice = data.referencePrice;
              this.listParams.plaGoodSpecId = data.plaGoodSpecId;
              this.listParams.minWeight = data.minWeight;
              this.listParams.maxWeight = data.maxWeight;
              this.listParams.goodLevelPrices = data.goodLevelPrices;
              this.listParams.goodFarmSites = data.goodFarmSites.length ? data.goodFarmSites : arr;
              const picture = data.picture;
              if (picture) {
                this.listParams.picture = picture.split(",");
              } else {
                this.listParams.picture = [];
              }
              const supplyRuleIds = data.supplyRuleIds;
              if (supplyRuleIds) {
                this.listParams.supplyRuleIds = supplyRuleIds.split(",");
              } else {
                this.listParams.supplyRuleIds = [];
              }
              for (let i = 0; i < this.listParams.supplyRuleIds.length; i++) {
                this.listParams.supplyRuleIds[i] = parseInt(this.listParams.supplyRuleIds[i]);
              }
              this.listParams.description = data.description;
            } else {
            }
          }
        })
        .catch(err => {
          this.formLoading = false;

          console.error(err);
        });
    },
    /**
     * 上传图片
     */
    doUpload() {
      this.uploading = true;
      const files = document.getElementById("uploadDom").files;
      const params = new FormData();
      params.append("file", files[0]);
      params.append("path", this.listParams.supplyId === 3 ? "fuwujia/images" : "upload/good-img");
      Vue.ajaxPost(this, global.apiImageUpload + "/oss/image/upload", params, { "Content-Type": "multipart/form-data" })
        .then(res => {
          if (res) {
            this.uploading = false;
            this.listParams.picture.push(res.data);
          } else {
            this.uploading = false;
            this.$message.error("上传图片失败");
          }
        })
        .finally(() => {
          this.uploading = false;
        });
    },
    /**
     * 删除图片
     * @param index
     */
    deleteImg(index) {
      this.listParams.picture.splice(index, 1);
    },
    /**
     * 限购规则的change事件
     * @param val
     */
    changeSupplyRuleIds(val) {
      this.supplyRuleIds = val;
    },
    /**
     * 保存条目数据
     * @param name
     */
    saveAdd(name) {
      this.isDisabled = true;
      this.$refs[name].validate(valid => {
        if (valid) {
          const listParams = Object.assign({}, this.listParams);
          listParams.price = parseFloat(listParams.price);
          listParams.referencePrice = parseFloat(listParams.referencePrice);
          if (listParams.picture.length === 0) {
            this.isDisabled = false;
            this.$message.error("请上传商品图片");
            return;
          } else {
            listParams.picture = listParams.picture.join(",");
          }
          if (listParams.supplyRuleIds) {
            listParams.supplyRuleIds = listParams.supplyRuleIds.join(",");
          } else {
            listParams.supplyRuleIds = [];
          }
          // 编辑状态下
          if (this.$route.query.id) {
            this.method = "PUT";
            listParams.id = this.$route.query.id;
          } else {
            this.method = "POST";
            if (listParams.id) {
              delete listParams.id;
            }
          }
          this.$http({
            url: global.apiUrl + "/good/gooddetail",
            method: this.method,
            body: listParams,
          })
            .then(res => {
              if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
                this.isDisabled = false;
                this.$message.success(res.body.info);
                this.$router.push({
                  name: "dishesManagement",
                });
              } else {
                this.isDisabled = false;
              }
            })
            .catch(err => {
              this.isDisabled = false;

              console.error(err);
            });
        } else {
          this.activeName = [];
          this.listParams.goodFarmSites.forEach((item, index) => {
            this.activeName.push(index);
          });
          console.log(this.activeName);
          this.isDisabled = false;
        }
      });
    },
    /**
     * 返回列表页
     */
    backToList() {
      this.$router.push({
        name: "dishesManagement",
      });
    },
  },
};
</script>

<style lang="less" scoped>
.el-collapse {
  margin-left: 60px;
  width: 40%;
  margin-bottom: 40px;
  .el-collapse-item__header {
    display: flex;
    align-items: center;
    justify-content: space-around;
    .el-form-item {
      margin-bottom: 0;
    }
  }
  .add {
    font-size: 24px;
    text-align: center;
  }
  .add::before {
    position: absolute;
    top: 8px;
    right: -30px;
  }
  .reduce {
    font-size: 24px;
    line-height: 24px;
  }
  .reduce::before {
    position: absolute;
    top: 8px;
    right: -60px;
  }
  .border {
    border: 1px dashed #f2f2f2;
  }
  .flex {
    display: flex;
    padding-top: 20px;
  }
}

.hx-form-container {
  .spec-unit-style {
    .el-form-item__content {
      margin-left: 10px !important;
    }
  }

  .wang-editor-style {
    width: 100%;
  }

  .upload-thumbnail-img,
  .thumbnail-img {
    width: 100px;
    height: 50px;
    border: 1px solid #ebeef5;
    position: relative;
    overflow: hidden;
    margin-left: 10px;

    .upload-icon {
      font-size: 20px;
      display: inline-block;
      margin-top: 15px;
      margin-left: 40px;
    }

    .hidden-upload {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
      filter: alpha(opacity=0); //filter 过滤器   兼容IE678
      z-index: 2;
      cursor: pointer;
    }

    .thumbnail-img-wrapped {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
    }

    .combined-img {
      position: relative;
      width: 100px;
      height: 50px;

      .hover-img {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        z-index: 999;
        opacity: 0;

        .close-btn {
          font-size: 22px;
          color: #fff;
          position: absolute;
          left: 50%;
          margin-left: -11px;
          top: 50%;
          margin-top: -11px;
        }
      }

      .hover-img:hover {
        opacity: 1;
        cursor: pointer;
        background-color: rgba(0, 0, 0, 0.5);
      }
    }
  }

  .wrap-thumbnail-img {
    width: 100%;
    height: 50px;
    margin-top: 10px;
    display: flex;
  }
}
</style>
